/**
 * @description 封装操作localstorage本地存储的方法
 * @param {string} key 缓存键
 * @param {*} value 缓存值
 * @param expire
 */
// 默认缓存期限为7天
const DEFAULT_CACHE_TIME = 60 * 60 * 24 * 7;
let storage = {
  getKey(key) {
    return key.toUpperCase();
  },
  // 设置缓存
  set(key, value, expire = DEFAULT_CACHE_TIME) {
    const stringData = JSON.stringify({
      value,
      expire: expire !== null ? new Date().getTime() + expire * 1000 : null,
    });
    localStorage.setItem(this.getKey(key), stringData);
  },
  // 读取缓存

  get(key, value = null) {
    const item = localStorage.getItem(this.getKey(key));
    if (item) {
      try {
        const data = JSON.parse(item);
        const { value, expire } = data;
        // 在有效期内直接返回
        if (expire === null || expire >= Date.now()) {
          return value;
        }
        this.remove(this.getKey(key));
      } catch (e) {
        return value;
      }
    }
    return value;
  },

  // 从缓存删除某项
  remove(key) {
    console.log(key, "搜索");
    localStorage.removeItem(this.getKey(key));
  },

  // 清空所有缓存
  clear() {
    localStorage.clear();
  },

  /**
   * cookie
   * @param {string} name cookie 名称
   * @param {*} value cookie 值
   * @param {number=} expire 过期时间
   * 如果过期时间为设置，默认关闭浏览器自动删除
   * @example
   */
  // 设置cookie
  setCookie(name, value, expire = DEFAULT_CACHE_TIME) {
    document.cookie = `${this.getKey(name)}=${value}; Max-Age=${expire}`;
  },

  // 根据名字获取cookie值
  getCookie(name) {
    const cookieArr = document.cookie.split("; ");
    for (let i = 0, length = cookieArr.length; i < length; i++) {
      const kv = cookieArr[i].split("=");
      if (kv[0] === this.getKey(name)) {
        return kv[1];
      }
    }
    return "";
  },

  // 根据名字删除指定的cookie
  removeCookie(key) {
    this.setCookie(key, 1, -1);
  },

  // 清空cookie，使所有cookie失效
  clearCookie() {
    const keys = document.cookie.match(/[^ =;]+(?==)/g);
    if (keys) {
      for (let i = keys.length; i--; ) {
        document.cookie = keys[i] + "=0;expire=" + new Date(0).toUTCString();
      }
    }
  },
};

// 暴露给外部访问
export default storage;
